<template>
  <el-select
    v-model="value"
    :disabled="disabled"
    multiple
    filterable
    allow-create
    default-first-option
    placeholder="Select or add SubID"
    no-data-text="Enter the value and press enter"
    @update:modelValue="update"
  >
    <el-option
      v-for="item in options"
      :key="item.id"
      :label="visibleName(item)"
      :value="item.attributes.name"
    />
  </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, watch, computed } from 'vue'

export default defineComponent({
  name: 'SubIdSelect',
  props: {
    modelValue: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    withDescription: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const options = computed(() => {
      const seen = new Set()

      return props.items.filter((item) => {
        const name = item.attributes.name

        if (seen.has(name)) {
          return false
        } else {
          seen.add(name)
          return true
        }
      })
    })

    const visibleName = (item) => {
      if (props.withDescription) {
        return `${item.attributes.description} (${item.attributes.name})`
      }
      return item.attributes.name
    }

    const update = (newValue: any) => {
      context.emit(
        'update:modelValue',
        newValue.map((x: any) => String(x))
      )
    }

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { update, value, options, visibleName }
  }
})
</script>
